import { graphql, compose } from 'react-apollo'
import { groupBy, keys } from 'ramda'
import { Layout, Table, Button, Modal, Input } from 'antd'
import moment from 'moment'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import XLSX from 'xlsx'

import createTrackingJandTMutation from '../graphql/mutations/CreateTrackingJandtApi'
import printLabelJandtMutation from '../graphql/mutations/printLabelJandt'
import editLabelAddressMutation from '../graphql/mutations/editLabelAddress'
import hookTrackingMutation from '../graphql/mutations/hookTracking'


import Footer from '../components/Footer'
import inboxLabel from '../helpers/inbox'
import labelsQuery from '../graphql/queries/labels'
import Navbar from '../components/Navbar'
import raceLabel from '../helpers/race'
import shopLabel from '../helpers/shop'

import '../css/table.css'

const { Content } = Layout
const { TextArea } = Input;

const getReference = (label) => {
  switch (label.app) {
    case 'shop': return label.referenceId
    case 'race': return label.data.bibs.join(', ')
    case 'inbox': return label.referenceId
    default: return '-'
  }
}

const labelMapper = {
  shop: shopLabel,
  race: raceLabel,
  inbox: inboxLabel,
}

class TrackingJandt extends Component {
  state = {
    selectedRowKeys: [],
    filteredRows: [],
    selectedLabels: [],
    filters: {},
    visibleModalEditAddress: false,
    labelIdEditAddress : '',
    editAddressDetail : '',
    searchKey: '',
  }

  async componentDidMount() {
    const { group } = this.props.match.params
    await this.props.labels.refetch({ group })
    this.onTableChange(null, {})
  }
  onSelectChange = (selectedRowKeys) => {
    const { labels: { labels = [] } } = this.props
    this.setState({
      selectedRowKeys,
      selectedLabels: labels.filter(label => selectedRowKeys.includes(label._id)),
    })
  }
  onTableChange = (pagination, filters, sorter) => {
    const { labels: { labels = [] } } = this.props
    this.setState({ filters })
    const filtersFunc = (label) => {
      const filterGroup = (filters.group && filters.group.length > 0 ? filters.group.includes(label.group) : true)
      const filterTracking = (filters.tracking ? filters.tracking.includes(this.checkHasTracking(label)) : true)
      const filterSendNoti = (filters.sendHook && filters.sendHook.length > 0 ? filters.sendHook.includes(this.checkSendNoti(label)) : true)
      return filterGroup && filterTracking && filterSendNoti
    }
    this.setState({
      filteredRows: labels.filter(filtersFunc),
      selectedRowKeys: [],
    })
  }

  checkSendNoti = (label) => {
    if (label.tracking) {
      return (label.tracking.sendHook ? 'send' : 'waiting')
    }
    return '-'
  }
  checkHasTracking= (label) => {
    if (label.tracking) {
      return 'has'
    }else{
      return 'empty'
    }
  }

  createjandttracking = async () => {
    const { selectedLabels } = this.state
    const labelsPromise = selectedLabels.filter(({ tracking }) => tracking === null).map(({ ...label }) => this.props.createTrackingJandT({ variables: { labelId: label._id } }))
    const response = await Promise.all(labelsPromise)

    let successCount = 0
    let failCount = 0

    response.forEach((record) => {
      console.log(record)
      if(record.data.createTrackingJandT._id === 'error'){
          failCount++
      }else{
        successCount++
      }
    })

    alert('Create Tracking Completed \n Success : ' + successCount + '\n Error : ' + failCount)
    window.location.reload();
  }

  sendTrackingNoti = async () => {
    const { selectedLabels } = this.state
    const labelsPromise = selectedLabels.filter(({ tracking }) => !!tracking).map(({ tracking, ...label }) => this.props.hookTracking({ variables: { labelId: label._id, trackingId: tracking._id } }))
    await Promise.all(labelsPromise)
    alert( 'Send Notification Complete' )
  }

  printLabelJandt = async () => {
    const { selectedLabels } = this.state
    const labelsPromise = selectedLabels.filter(({ tracking }) => !!tracking).map(({ tracking }) => this.props.printLabelJandt({ variables: { trackingId: tracking._id } }))
    const response = await Promise.all(labelsPromise)

    var listLabelUrl = ''
    listLabelUrl = listLabelUrl+"<H2>Print Label J&T</H2>"
    response.forEach((record) => {
      if(record.data.printLabelJandt !== null){
        listLabelUrl = listLabelUrl+" - <a href='"+record.data.printLabelJandt.labelUrl+"' target='_blank'>"+ record.data.printLabelJandt.labelUrl +"</a><br><br>"
      }
    })

    if(listLabelUrl !== "<H2>Print Label J&T</H2>"){
      const wnd = window.open('about:blank', '')
      wnd.document.write(listLabelUrl)
      wnd.document.close()  
    }else{
      alert('No Label To Print')
    }
  }

  exportExcel = async () => {
    const { selectedLabels } = this.state
    const excelData = selectedLabels.map((label) => {
      const items = label.data.items ? label.data.items.map(item => `[${item.amount}] ${item.name}`) : []
      const shirts = label.data.shirts ? label.data.shirts.map(shirt => `[1] ${shirt}`) : []
      return {
        'Tracking type': label.tracking ? label.tracking.carrier : '',
        'Tracking code': label.tracking ? label.tracking.code : '',
        'Label ID': label._id,
        Reference: getReference(label),
        Recipient: label.recipient.replace(/\s{1,}/g, ' ').replace(/\u200B/g, ''),
        Address: label.address.replace(/\s{1,}/g, ' ').replace(/\u200B/g, ''),
        Phone: label.data.phones.join(', '),
        Items: [...items, ...shirts].join(',\n'),
        Scaned: label.tracking ? moment(label.tracking.scannedAt).format('YYYY-MM-DD HH:mm:SS') : '',
        Count: label.data.count,
        Email: label.data.emails ? label.data.emails[0] : '',
      }
    })
    const workbook = XLSX.utils.book_new()
    const worksheet = XLSX.utils.json_to_sheet(excelData)
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1')
    XLSX.writeFile(workbook, `labels-${moment().format('YYYYMMDDHHmmSS')}.xlsx`)
  }
  printLabel = async () => {
    const { selectedLabels } = this.state
    const groupedLabels = groupBy(label => label.app, selectedLabels)
    const groups = keys(groupedLabels)
    groups.asyncForEach((group) => {
      const labels = groupedLabels[group]
      const html = labelMapper[group].genLabel(labels)
      const wnd = window.open('about:blank', '')
      wnd.document.write(html)
      wnd.document.close()
    })
  }

  // control Modal
  showEditAddress(record){
    this.setState({
      visibleModalEditAddress: true,
      labelIdEditAddress : record._id,
      editAddressDetail: record.address
    });
  }

  handleCancelEditAddress = () => {
    this.setState({
      visibleModalEditAddress: false,
      labelIdEditAddress : '',
      editAddressDetail: ''
    });
  };

   handleSubmitEditAddress = async () => {
    const addressEdit = this.state.editAddressDetail
    const labelId = this.state.labelIdEditAddress
    await this.props.editLabelAddress({ variables: { labelId: labelId, addressEdit: addressEdit} })
    this.setState({
      visibleModalEditAddress: false,
    });
  };

  changeValueAddress = (e) => {
    const { target: { value: addressEdited } } = e
    this.setState({
      editAddressDetail: addressEdited
    })
  }
  // end Modal

  render() {

    let app = ''
    const searchKey = this.state.searchKey.toLowerCase()
    let { labels: { loading, labels = [] } } = this.props
    const { selectedRowKeys, filteredRows } = this.state
    labels.map( label => app = label.app )

    if(searchKey !== ''){
      if(app === 'race'){
        labels = labels.filter(({ data }) => data.bibs.includes(searchKey))    
      }else if(app === 'shop'){
        labels = labels.filter(({ referenceId }) => referenceId.includes(searchKey))    
      }
    }


    const rowSelection = {
      selectedRowKeys,
      onChange: selected => this.onSelectChange(selected),
      hideDefaultSelections: true,
      selections: [
        {
          key: 'all-data',
          text: 'Select All Data',
          onSelect: () => {
            this.setState({
              selectedRowKeys: filteredRows.map(label => label._id),
              selectedLabels: filteredRows,
            })
          },
        },
        {
          key: 'all-tracking',
          text: 'Select All Tracking',
          onSelect: () => {
            this.setState({
              selectedRowKeys: filteredRows.filter(label => !!label.tracking).map(label => label._id),
              selectedLabels: filteredRows,
            })
          },
        },
        {
          key: 'non-tracking',
          text: 'Select No Tracking',
          onSelect: () => {
            this.setState({
              selectedRowKeys: filteredRows.filter(label => label.tracking === null).map(label => label._id),
              selectedLabels: filteredRows,
            })
          },
        },
        {
          key: 'clear-selected',
          text: 'Clear selected',
          onSelect: () => {
            this.setState({
              selectedRowKeys: [],
              selectedLabels: [],
            })
          },
        },
      ],
      onSelection: this.onSelection,
    }
    const filterGroup = keys(groupBy(label => label.group, labels)).map(label => ({ text: label, value: label }))
    const filterTracking = [{ text: 'Tracking', value: 'has' }, { text: '-', value: 'empty' }]
    const filterSendNoti = [{ text: 'Send', value: 'send' }, { text: 'Waiting', value: 'waiting' }]
    const columns = [
      {
        title: 'Group',
        dataIndex: 'group',
        key: 'group',
        width: 150,
        filters: filterGroup,
        onFilter: (value, record) => record.group === value,
      },
      {
        title: 'Label ID',
        key: 'labelId',
        width: 100,
        className: 'text-center',
        render: record => (<span>{record._id}<br />({record.app})</span>),
      },
      {
        title: 'Reference',
        key: 'reference',
        width: 100,
        className: 'text-center',
        render: getReference,
      },
      {
        title: 'Recipient',
        dataIndex: 'recipient',
        key: 'recipient',
        width: 150,
      },
      {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
      },
      {
        title: 'Count',
        key: 'count',
        width: 60,
        className: 'text-center',
        render: record => record.data.count,
      },
      {
        title: 'Items',
        key: 'item',
        width: 200,
        /* eslint react/no-array-index-key: 0 */
        render: record => (
          <ul style={{ paddingLeft: '20px' }}>
            {record.data.items && record.data.items.map(item => (
              <li key={`${record.referenceId} ${item.name}`}>[{item.amount}] {item.name}</li>
            ))}
            {record.data.shirts && record.data.shirts.map((shirt, index) => (
              <li key={`${record.referenceId} ${shirt} ${index}`}>{shirt}</li>
            ))}
          </ul>
        ),
      },
      {
        title: 'Tracking',
        key: 'tracking',
        width: 100,
        className: 'text-center',
        filters: filterTracking,
        onFilter: (value, record) => this.checkHasTracking(record) === value,        
        render: record => (record.tracking ? <span>[{record.tracking.carrier}]<br />{record.tracking.code}</span> : '-'),
      },
      {
        title: 'Send noti',
        key: 'sendHook',
        width: 80,
        className: 'text-center',
        filters: filterSendNoti,
        onFilter: (value, record) => this.checkSendNoti(record) === value,
        /* eslint no-nested-ternary: 0 */
        render: record => (record.tracking ? (record.tracking.sendHook ? 'Send' : 'Waiting') :         
          <Button type="link" onClick={ () => this.showEditAddress(record)}>แก้ไขที่อยู่</Button>),
      },
    ]
    return (
      <Layout>
        <Navbar selected="label:3" />
        <Content style={{ padding: '0 20px' }}>
          <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
            <h2>
              Labels <small>(Selected {selectedRowKeys.length} rows{keys(this.state.filters).every(key => this.state.filters[key].length === 0) ? '' : `, Filtered ${filteredRows.length} rows`})</small>
              <Button
                type="primary"
                onClick={this.createjandttracking}
                disabled={this.state.selectedLabels.length === 0}
                style={{ float: 'right' }}
              >
                Create Tracking
              </Button> 
              <Button
                type="primary"
                onClick={this.sendTrackingNoti}
                disabled={this.state.selectedLabels.length === 0}
                style={{ float: 'right' ,marginRight: '10px' }}
              >
                Send tracking
              </Button>
              <Button
                type="primary"
                onClick={this.printLabelJandt}
                disabled={this.state.selectedLabels.length === 0}
                style={{ float: 'right', marginRight: '10px' }}
              >
                Print Label J&T
              </Button> 
              <Button
                type="primary"
                onClick={this.exportExcel}
                style={{ float: 'right', marginRight: '10px' }}
              >
                Export excel
              </Button>
            </h2>
            <h2>
            <Input.Search placeholder='Search Reference' style={{ float: 'right', marginBottom: '10px', width: '250px'}} onChange={ e => this.setState({searchKey: e.target.value})} /><br />
            </h2>
            <Table
              rowSelection={rowSelection}
              dataSource={labels}
              columns={columns}
              rowKey="_id"
              pagination={{ pageSize: 50 }}
              size="middle"
              onChange={this.onTableChange}
              loading={loading}
              bordered
            />
          </div>

          <Modal
          title="Edit Address"
          visible={this.state.visibleModalEditAddress}
          onOk={this.handleSubmitEditAddress}
          onCancel={this.handleCancelEditAddress}
          >
            <b>Label Id</b> : {this.state.labelIdEditAddress}<br />
            <b>Address</b> : <TextArea rows={4} value={this.state.editAddressDetail} onChange={this.changeValueAddress}/>
          </Modal>

        </Content>
        <Footer />
      </Layout>
    )
  }
}
TrackingJandt.propTypes = {
  labels: PropTypes.shape({
    error: PropTypes.object,
    loading: PropTypes.bool,
    labels: PropTypes.array,
    refetch: PropTypes.func,
  }).isRequired,
  createTrackingJandT: PropTypes.func.isRequired,
  printLabelJandt: PropTypes.func.isRequired,
  editLabelAddress: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.object,
  }).isRequired,
}
TrackingJandt.defaultProps = {}

export default compose(
  graphql(createTrackingJandTMutation, { name: 'createTrackingJandT' }),
  graphql(labelsQuery, { name: 'labels', options: { variables: { group: '' } } }),
  graphql(printLabelJandtMutation, {name: 'printLabelJandt'}),
  graphql(editLabelAddressMutation, {name: 'editLabelAddress'}),
  graphql(hookTrackingMutation, { name: 'hookTracking' }),
)(TrackingJandt);


// WEBPACK FOOTER //
// ./src/pages/TrackingJandt.js